import styled from "styled-components";

const EbooksContainer = styled.div`
	/* Container for ebooks grid layout */
`;

const ViewMoreWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 120px;
`;

export { EbooksContainer, ViewMoreWrapper };